import React from 'react';
import { SystemAdminPage } from '../SystemAdminPage';

export const AuditPage: React.FC = () => {
  return <SystemAdminPage initialTab="audit" />;
};
